module.exports = __webpack_public_path__ + "coin_BNB.svg?1aa88810b9f05826b0ce034c0799f7e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_BNB.svg
// module id = 1120
// module chunks = 2